<template>
    <div v-if="body_show">
        <!-- 我的头部 -->
        <public-top :headimgurl="headimgurl" :nickname="nickname"></public-top>
        <!-- 影响力收益 -->
        <div class="influence-gain">
            <h4>影响力收益</h4>
            <h5><span>¥</span>{{money}}</h5>
            <van-button  :class="['btn',money<=0?'on':'']" type="default"  @click="money<=0?$toast('没有可提现收益！'):$router.push('/my_account')" >提现</van-button>
        </div>
        <!-- 成功推荐 -->
        <div v-if="list.length>0" class="Successful">
            <h4>成功推荐</h4>
            <div class="Successful-box" v-for="(item,index) in list" :key="index" >
                <img :src="item.headimgurl" >
                <h3>{{item.nickname}}</h3>
                <span>已报名</span>
            </div>
        </div>
    </div>
</template>

<script>
import { myshare } from "@/api/person"
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            body_show:false,
            headimgurl: '',
            nickname: '',
            money:0,
            list:[],
        }
    },
    methods:{
        pullData() {
            myshare().then(data => {
                this.body_show = true;
                this.headimgurl = data.headimg;
                this.nickname = data.nickname;
                this.money = data.total;
                this.list = data.sharelist;
        });
      },
    },
    created() {
      this.pullData();
      shareCon("index",this);
    }
}
</script>

<style lang="scss" scoped>
    .influence-gain{
        background: #fff;
        margin: 30px auto 30px;
        padding: 30px 50px 40px;
        h4{
            font-size: 26px;
            color: #333333;
            margin-bottom: 40px;
            line-height: 1;
        }
        h5{
            line-height: 1;
            font-size: 54px;
            color: #F57F17;
            padding-bottom: 20px;
            span{
                font-size: 34px;
            }
            border-bottom: 1px solid #ccc; 
        }
    }
    .Successful{
        background: #fff;
        padding: 30px 50px;
        h4{
            font-size: 26px;
            color: #333333;
            line-height: 1;
            margin-bottom: 20px;
        }
        .Successful-box{
            padding: 20px 0;
            position: relative;
            border-bottom: 1px solid #ccc; 
            img{
                width:60px;
                height:60px;
                border-radius:50%;
                margin-right: 20px;
            }
            h3{
                font-size: 32px;
                color: #333333;
                position: absolute;
                left: 80px;
                transform: translateY(-50%);
                top: 50% 
            }
            span{
                color: #F57F17;
                position: absolute;
                right: 0;
                transform: translateY(-50%);
                top: 50% ;
                font-size:26px;
            }
        }
    }

</style>
<style lang="scss">
    .influence-gain .btn{
        width:100%;
        height:80px;
        background:rgba(235,80,50,1);
        color: #fff;
        border-radius:8px;
        box-sizing: border-box;
        margin-top: 30px;
        cursor: pointer;
    }
    .influence-gain .btn.on{
        background-color: #cccccc;
    }
</style>